import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";

const FAQSection = () => {
    const [openIndex, setOpenIndex] = useState(null);
    const [sections, setSections] = useState([]);
    const [loading, setLoading] = useState(true);

    const toggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    // ✅ Fetch FAQ API
    useEffect(() => {
        const fetchFaq = async () => {
            try {
                const res = await fetch(
                    `${process.env.REACT_APP_API_LOCAL_URL}faq`
                );

                if (!res.ok) throw new Error("Failed to load FAQ");

                const data = await res.json();

                setSections(data);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchFaq();
    }, []);

    let globalIndex = 0;

    if (loading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-primary" />
            </div>
        );
    }

    return (
        <>
            <Helmet>
                <title>よくある質問</title>
            </Helmet>

            <div className="row mt-4">
                <div className="col-12">
                    <h1 className="text-center mb-5 fw-bold">よくある質問</h1>
                </div>
            </div>

            <div className="row mt-4">
                <div className="col-12">

                    {sections.map((section, sIdx) => (
                        <div key={sIdx} className="mb-4">

                            {/* Section Title */}
                            <h5 className="fw-bold border-start border-4 ps-3 mb-3">
                                {section.title}
                            </h5>

                            <div className="accordion">

                                {section.faqs.map((faq) => {
                                    const index = globalIndex++;

                                    return (
                                        <div
                                            className="accordion-item mb-2 rounded shadow-sm"
                                            key={index}
                                        >
                                            <h2 className="accordion-header">
                                                <button
                                                    className={`accordion-button ${
                                                        openIndex !== index ? "collapsed" : ""
                                                    }`}
                                                    onClick={() => toggle(index)}
                                                >
                                                    {faq.question}
                                                </button>
                                            </h2>

                                            <div
                                                className={`accordion-collapse collapse ${
                                                    openIndex === index ? "show" : ""
                                                }`}
                                            >
                                                <div className="accordion-body text-muted">
                                                    {faq.answer}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    ))}

                </div>
            </div>
        </>
    );
};

export default FAQSection;